import { createTheme } from "@mui/material";

export const customTheme = createTheme({
  typography: {
    fontFamily: 'PlayfairDisplay-Regular',  // Font personalizzati
    h1: {
      fontSize: "2.5rem",
      fontWeight: 700,
    },
    body1: {
      fontSize: "1rem",
      lineHeight: 1.5,
    },
  },
  palette: {
    primary: {
      main: "#145444",
    },
    secondary: {
      main: "#EADDD4",
    },
    tertiary: {
      main: "#daa89b",
      light: "#f4cfc3",
      dark: "#b97b6e"
    },
    background: {
      main: "#f0eae6",
      light: "#f0eae6",
      dark: "#f0eae6",
    }
  },

  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          width: "auto",
          borderRadius: "12px",  // Optional: per bordi arrotondati più moderni
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)", // Optional: ombreggiatura leggera
        },

        '@media (min-width:768px)': {
          width: "600px", // Imposta la larghezza a 400px sui dispositivi desktop
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: "2rem",  // Padding di base
        },
      },
    },
    // MuiOutlinedInput: {
    //   styleOverrides: {
    //     root: {
    //       input: {
    //         color: "white",                   // Testo bianco
    //         backgroundColor: "theme.palette.tertiary.main",       // Sfondo leggermente più chiaro del verde scuro
    //         borderRadius: "8px",              // Bordi arrotondati
    //       },
    //       "& fieldset": {
    //         borderColor: "#c3f0f0",           // Bordo grigio chiaro tendente all’azzurro
    //       },
    //       "&:hover fieldset": {
    //         borderColor: "#ffffff",           // Bordo più chiaro quando si passa sopra
    //       },
    //       "&.Mui-focused fieldset": {
    //         borderColor: "theme.palette.tertiary.light",           // Bordo bianco quando è in focus
    //       },
    //     },
    //   },
    // },
    // MuiInputLabel: {
    //   styleOverrides: {
    //     root: {
    //       color: "#c3f0f0",                  // Colore del label (azzurro chiaro)
    //     },
    //   },
    // },
  },
});